import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2 px-2" }
const _hoisted_2 = { class: "py-2 d-none d-md-block" }
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = { class: "py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.partnerName), 1),
    _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.partnerSlug), 1),
    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.usedSeats), 1),
    _createElementVNode("td", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.partnerSeats) = $event))
      }, null, 512), [
        [_vModelText, _ctx.partnerSeats]
      ]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("button", {
        class: "ms-4 btn btn-primary btn-sm",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateSeats && _ctx.updateSeats(...args)))
      }, "Save Seats")
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}